import { combineReducers } from 'redux';
import { myPageData } from './myPageData';

export const myPage = combineReducers({
    myPageData,
})